import { createErrorMessageTypeGuard } from '../createErrorMessageTypeGuard';
import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type GroupInfo = {
   groupName: string;
   translatedGroupName: string;
   elementId: string;
   url: string;
   active?: boolean;
};

export type Tab = {
   translatedName: string;
   url: string;
   elementId: string;
   active?: boolean;
};

export interface Tabs {
   [key: string]: Tab;
}

export type Group = {
   groupInfo: GroupInfo;
   tabs?: Tabs;
};

export type SideBar = {
   groups: Group[];
};

export async function getSideBar(
   activeTab: string,
   common: CommonRequestOptions = {}
): Promise<SideBar> {
   return makeRequest('get', `manage/side_bar/${activeTab}`, common);
}

export type GetSideBarErrorCode = 'manage.side_bar_not_found';
getSideBar.errorMessages = createErrorMessageTypeGuard<GetSideBarErrorCode>();
